import { $session } from "./session.js";
import { $cookies } from "./cookies.js";
import axios from "axios";

const $axiosInterceptor = 
{
    // ------------------------------------
    // axios 인터셉터 요청
    // ------------------------------------
    interceptorsRequest()
    {
        axios.interceptors.request.use(
            function (config) 
            {
                // 권한체크하는 요청인 경우만 Authrization 설정
                if (config.headers["_AUTH_"] == "true") {
                    let accessToken = $cookies.get("ACCESS_TOKEN");
                    if (accessToken) {
                        console.log("0. 호출하기전 Access 토큰 설정 =" + accessToken);
                        config.headers["Authorization"] = `Bearer ${accessToken}`;
                    } else {
                        console.log("0. 권한체크해야 하는데 토큰 미존재");
                        alert("Plean sign in again(4) !");
                        location.href = $session.getSignInUrl();
                    }
                }
                return config;
            },
            function (error) 
            {
                // 오류 요청 가공
                return Promise.reject(error);
            }
        );        
    },  
    // ------------------------------------
    // axios interceptor response
    // ------------------------------------
    interceptorsResponse()
    {
        let self = this;
        axios.interceptors.response.use(
            function (response) 
            {
                return response;
            },
            function (error) 
            {
                let status = error.response.status;
                // Access 토큰 만료(401) => 토큰 갱신 호출
                if (status == 401) {
                    self._interceptors401(error);
                } else if (status == 412) {
                    console.log("412");
                } else {
                    self._interceptorsOther(error);
                }
                return Promise.reject(error);
            }
        );
    },    
    // 액세스토큰 만료 호출
    _interceptors401(error)
    {
        console.log("1.Access 토큰 만료");
        let originalRequest = error.config;
        let refreshToken = $cookies.get("REFRESH_TOKEN");
        if (refreshToken) {
            let url = "/user-app/v1/login/refresh-token";
            let param = {"REFRESH_TOKEN": refreshToken};
            axios.post(url, param).then((response) => {
                let json = response.data;
                console.log("2.Access 토큰 재발행 성공");
                // Refresh 토큰으로 새로 발급받은 토큰 설정
                $session.setCookies(json.ACCESS_TOKEN, json.REFRESH_TOKEN);
                return axios(originalRequest);
            }).catch((error) => {
                // Refresh 토큰 만료시 로그인 처리    
                let status = error.response.status;
                if (status == 400) {
                    console.log("3.refresh 토큰 만료");
                    $session.removeCookies();
                    alert("Plean sign in again(2) !");
                    location.href = $session.getSignInUrl();
                }
            });
        } else {
            console.log("2.refresh 토큰 미존재");
            alert("Plean sign in again(3) !");
            location.href = $session.getSignInUrl();
        }
    },
    // 기타오류 호출
    _interceptorsOther(error)
    {
        let status = error.response.status;
        // 1. 토큰이 접근권한이 존재하지 않을 때 
        if (status === 403) {
            // 서버컨드롤러에 도달하기 전에 SpringSecurity에서 뱉는 메세지
            if (error.response.data.error == "Forbidden") {
                error.response.data.errors = [{"code":"ERRORS", "msg":"Access role does not exist"}];
            }
        // 2. 유효성 오류(412) : result.addValidateErrors()
        } else if (status === 412) {
            // skip
        // 3. 부적절한 요청 (400) : result.addResponseErrors()
        } else if (status === 400) {
            // skip
        // 5. 시스템 오류 (500) : try ~ catch { LogUtil.error() }  
        } else {
            let errorData = error.response.data;
            // 2-1. 개발자 시스템 오류 메세지 처리
            if (errorData.errors && errorData.errors.length > 0) {
                // skip 
            // 2-2. 서버 접속 장애 오류 발생시    
            } else if (typeof errorData === "string" || errorData instanceof String) {
                if (errorData.indexOf("ECONNREFUSED") > -1) {
                    error.response.data = {}; // 문자열을 json객체로 변환
                    error.response.data.errors = [{"code":"ERRORS", "msg":"A failure has occurred in connecting to the server."}];
                }    
            }
        }
    },

}

export {
    $axiosInterceptor
}